import { useEffect, useState } from 'react';
import { getRoleDashboardSummary } from 'Pages/User/service/index.Service';
import RolesCard from 'Components/Card/RolesCard';
import { Icon } from 'Components';

interface Props {
	tenantId?: string | number;
}

interface RoleDashboardSummary {
	primaryRolesCount: number;
	customRolesCount: number;
	usersCount: number;
}

const RolesCardDashboard = ({ tenantId }: Props) => {
	const [data, setData] = useState<RoleDashboardSummary>({
		primaryRolesCount: 0,
		customRolesCount: 0,
		usersCount: 0
	});

	useEffect(() => {
		const fetchDashboard = async () => {
			try {
				const response = await getRoleDashboardSummary(tenantId);
				setData(response);
			} catch (error) {
				console.error('Failed to fetch role dashboard summary', error);
			}
		};

		fetchDashboard();
	}, [tenantId]);

	const cards = [
		{
			icon: <Icon type='table' />,
			label: 'Total Roles',
			value: data.primaryRolesCount + data.customRolesCount,
			tooltip: 'All roles in the system',
			valueColor: 'blue' as const
		},
		{
			icon: <Icon type='gear' />,
			label: 'Primary Roles',
			value: data.primaryRolesCount,
			tooltip: 'Default System Roles',
			valueColor: 'blue' as const
		},
		{
			icon: <Icon type='settingsIcon' />,
			label: 'Custom Roles',
			value: data.customRolesCount,
			tooltip: 'Created by you',
			valueColor: 'blue' as const
		},
		{
			icon:<Icon type='multiusers' />,
			label: 'Total Users',
			value: data.usersCount,
			tooltip: 'Users with role assigned',
			valueColor: 'blue' as const
		}
	];

	return (
		<div className="roles-card-dashboard">
			{cards.map((card) => (
				<RolesCard
					key={card.label}
					{...card}
				/>
			))}
		</div>
	);
};

export default RolesCardDashboard;